export const STATUS_COLORS: Record<string, { bg: string; color: string }> = {
    onboarded: { bg: '#22c55e', color: '#ffffff' },
    passed: { bg: '#fee2e2', color: '#dc2626' },
    rejected: { bg: '#fee2e2', color: '#dc2626' },
    'deal ongoing': { bg: '#e1ffe1', color: '#49a71b' },
    'deal running': { bg: '#e1ffe1', color: '#49a71b' },
    new: { bg: '#dbeafe', color: '#2563eb' },
    qualified: { bg: '#dbeafe', color: '#2563eb' },
};

export type SortKey =
    | 'orgName'
    | 'leadStatus'
    | 'relationshipStatus'
    | 'revenue'
    | 'existingDebt'
    | 'equityRaised'
    | 'state'
    | 'similarityScore';
export type SortDir = 'asc' | 'desc';

export const COLUMNS = [
    { key: 'orgName', label: 'Entity', sortable: true, width: '180px' },
    { key: 'similarityScore', label: 'Similarity Score', sortable: true, width: '120px' },
    { key: 'leadStatus', label: 'Lead Status', sortable: true, width: '120px' },
    { key: 'relationshipStatus', label: 'Relationship Status', sortable: true, width: '150px' },
    { key: 'revenue', label: 'Revenue', sortable: true, width: '100px' },
    { key: 'ebitdaPct', label: 'EBITDA %', sortable: false, width: '90px' },
    { key: 'existingDebt', label: 'Existing Debt', sortable: true, width: '120px' },
    { key: 'investors', label: 'Top Investors', sortable: false, width: '160px' },
    { key: 'equityRaised', label: 'Equity Raised', sortable: true, width: '110px' },
    { key: 'state', label: 'State', sortable: true, width: '130px' },
] as const;
